import angular from 'angular';
import FeaturedProductsComponent from './featured-products.component';

let FeaturedProductsModule = angular.module('catalog.featuredProducts', [])
  .component('featuredProducts', FeaturedProductsComponent);

export default FeaturedProductsModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/featured-products/featured-products.js
 **/